import i18n from '../../../i18n/config';
// arsenal-tpms/frontend/src/components/schematics/VehicleTelemetryModal/constants.js
// CONSTANTES Y CONFIGURACIÓN DEL MODAL DE TELEMETRÍA

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

// Configuración de rangos de tiempo
export const TIME_RANGE_CONFIG = {
  '1hour': { label: '1H', duration: 1 / 24 },
  [i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.1day')]: { label: '1D', duration: 1 },
  '1week': { label: '1S', duration: 7 },
  '1month': { label: '1M', duration: 30 },
  '3months': { label: '3M', duration: 90 }
};

export const TIME_RANGE_OPTIONS = Object.entries(TIME_RANGE_CONFIG).map(([value, config]) => ({
  label: config.label,
  value,
  ...config
}));

// Colores para las series de datos
export const SERIES_COLORS = [
  '#1976d2',
  '#dc004e',
  '#388e3c',
  '#f57c00',
  '#7b1fa2',
  '#c2185b',
  '#0288d1',
  '#d32f2f'
];

// Configuración de métricas
export const METRIC_TYPE_MAP = {
  'pressure': 'PSI',
  'temperature': 'TEMP',
  [i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.acceleration')]: 'ACC'
};

// Tabs disponibles
export const AVAILABLE_TABS = [
  { label: '', component: 'charts' },
  { label: '', component: 'table' },
  { label: '', component: 'comparison' }
];

// Configuración de highcharts boost para optimización
export const HIGHCHARTS_BOOST_CONFIG = {
  enabled: true,
  useGPUTranslations: true,
  seriesThreshold: 1
};

// Configuración de idioma para Highcharts
export const HIGHCHARTS_LANG_CONFIG = {
  months: [i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.enero'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.febrero'), 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.agosto'), 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  weekdays: ['Domingo', i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.lunes'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.martes'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal copy.miercoles'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.jueves'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.viernes'), i18n.t('hardcoded.components_schematics_vehicletelemetrymodal copy.sabado')],
  shortMonths: [i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.ene'), 'feb', i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.mar'), 'abr', 'may', 'jun',
    'jul', 'ago', 'sep', 'oct', 'nov', i18n.t('hardcoded.components_schematics_vehicletelemetrymodal.dic')]
};

export default {
  GOOGLE_MAPS_API_KEY,
  TIME_RANGE_CONFIG,
  TIME_RANGE_OPTIONS,
  SERIES_COLORS,
  METRIC_TYPE_MAP,
  AVAILABLE_TABS,
  HIGHCHARTS_BOOST_CONFIG,
  HIGHCHARTS_LANG_CONFIG
};